import React from 'react';
import { withPrefix } from 'gatsby';
import { Container } from '@edx/paragon';
import { FormattedMessage } from 'gatsby-plugin-react-intl';
import CloudflareImage from '@prospectus/common/ui/CloudflareImage';

function AboutEdx() {
  return (
    <Container size="lg" className="about-edx mb-4">
      <div className="row">
        <div className="col-lg-6 about-edx-content">
          <div className="row">
            <div id="about-edx" className="col-12 headline skip-link-target mb-3 mb-sm-3.5" tabIndex="-1">
              <FormattedMessage
                id="prospectus.edx.aboutEdx.headline"
                defaultMessage="Whether you are looking to accelerate your career, earn a degree, or learn something for personal reasons, {highlightedText}."
                description="Headline giving an overview of what edX is and how it can help people."
                values={{
                  highlightedText: (
                    <FormattedMessage
                      id="prospectus.edx.aboutEdx.headline.highlight"
                      defaultMessage="edX has the courses for you"
                      description="Bold text highlighting the headline text stating that edX has the courses users want."
                    >
                      {text => <span className="font-weight-bold">{text}</span>}
                    </FormattedMessage>
                  ),
                }}
              />
            </div>
            <div className="col-12 facts">
              <div className="row">
                <div className="fact col-12 col-md-6 mb-sm-3.5">
                  <FormattedMessage
                    id="prospectus.edx.aboutEdx.heading.propelling"
                    defaultMessage="Propelling"
                    description="Heading stating that learning via edX can drive your career."
                  >{title => <h3 className="h3 title ">{title}</h3>}
                  </FormattedMessage>
                  <FormattedMessage
                    id="prospectus.edx.aboutEdx.description.propelling"
                    defaultMessage="Drive your career forward with university-backed credit programs and verified certificates"
                    description="Text describing how edX can drive your career."
                  >{text => <span className="content">{text}</span>}
                  </FormattedMessage>
                </div>
                <div className="fact col-12 col-md-6 mb-sm-3.5">
                  <FormattedMessage
                    id="prospectus.edx.aboutEdx.heading.convenient"
                    defaultMessage="Convenient"
                    description="Heading stating that edX courses and programs are convenient."
                  >{title => <h3 className="h3 title">{title}</h3>}
                  </FormattedMessage>
                  <FormattedMessage
                    id="prospectus.edx.aboutEdx.description.convenient"
                    defaultMessage="Study and demonstrate knowledge on your schedule"
                    description="Text describing how edX courses and programs are convenient."
                  >{text => <span className="content">{text}</span>}
                  </FormattedMessage>
                </div>
                <div className="fact col-12 col-md-6 mb-sm-3.5">
                  <FormattedMessage
                    id="prospectus.edx.aboutEdx.heading.flexible"
                    defaultMessage="Flexible"
                    description="Heading stating that edX is flexible."
                  >{title => <h3 className="h3 title">{title}</h3>}
                  </FormattedMessage>
                  <FormattedMessage
                    id="prospectus.edx.aboutEdx.description.flexible"
                    defaultMessage="Try a course before you pay"
                    description="Text describing how edX is flexible."
                  >{title => <span className="content">{title}</span>}
                  </FormattedMessage>
                </div>
                <div className="fact col-12 col-md-6 mb-sm-3.5">
                  <FormattedMessage
                    id="prospectus.edx.aboutEdx.heading.supportive"
                    defaultMessage="Supportive"
                    description="Heading stating that edX is supportive of users."
                  >{title => <h3 className="h3 title">{title}</h3>}
                  </FormattedMessage>
                  <FormattedMessage
                    id="prospectus.edx.aboutEdx.description.supportive"
                    defaultMessage="Learn with university partners and peers from around the world"
                    description="Text describing how edX is supportive of users."
                  >{title => <span className="content">{title}</span>}
                  </FormattedMessage>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-6 align-items-center justify-content-center d-none d-lg-flex map">
          <CloudflareImage
            url={withPrefix('/assets/world_map.png')}
            className="img-fluid"
            height={312}
            width={400}
          />
        </div>
      </div>
    </Container>
  );
}

export default AboutEdx;
